/**
 * @generated SignedSource<<87b63e83f179866a750c908377f9dac3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DepartureLocationListRow_departureLocation$data = {
  readonly id: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"SortableEntityTableRow_entity">;
  readonly " $fragmentType": "DepartureLocationListRow_departureLocation";
};
export type DepartureLocationListRow_departureLocation$key = {
  readonly " $data"?: DepartureLocationListRow_departureLocation$data;
  readonly " $fragmentSpreads": FragmentRefs<"DepartureLocationListRow_departureLocation">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DepartureLocationListRow_departureLocation",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SortableEntityTableRow_entity"
    }
  ],
  "type": "DepartureLocation",
  "abstractKey": null
};

(node as any).hash = "1a3df9cf200abd41555ec75d8535bd25";

export default node;
